import { Theme, ThemeOptions } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';
import { UnknownTenantError } from './unknownTenantError';
import { getTheme as getFinanzcheckTheme } from './theme/finanzcheck';
import { getTheme as getSmavaTheme } from './theme/smava';

export type OverrideFactory = (theme: Theme) => OverridesStyleRules;

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    tertiary: PaletteColor;
  }
}
export interface GetThemeProps {
  optionsWithThemeValues?: (theme: Theme) => ThemeOptions;
  options?: ThemeOptions;
}
export type GetTheme = (themeProps: GetThemeProps) => Theme;

export enum Tenant {
  Smava = 'Smava',
  Finanzcheck = 'Finanzcheck',
}

const themeLookup = {
  [Tenant.Smava]: getSmavaTheme,
  [Tenant.Finanzcheck]: getFinanzcheckTheme,
};

export function getTheme(tenant: Tenant, themeOptions: GetThemeProps = {}) {
  const getThemeForTenant = themeLookup[tenant];
  if (!getThemeForTenant) {
    throw new UnknownTenantError(tenant);
  }

  return getThemeForTenant(themeOptions);
}
